import { ERROR_MESSAGES } from '../../constants';

const FAILURE_REASONS = {
  MARKET_STATUS: 'Your offer could not be submitted due to a problem with the market.',
  RUNNER_STATUS: 'Your offer could not be submitted due to a problem with the runner.',
  OFFER_STATUS: 'There was a problem with your offer and it could not be submitted.',
  SERVER_ERROR: 'There was a problem with your offer and it could not be submitted.',
  DELAY_TIMEOUT: 'There was a problem with your offer and it could not be submitted.',
  FLUSHED: 'The offer was not submitted because the market was flushed and/or closed,'
};

// eslint-disable-next-line import/prefer-default-export
export const getRealOfferStatus = (offer) => {
  if (!offer) {
    return {
      delay: 0,
      status: 'unknown',
      processingState: 'unsubmitted',
      editTime: '',
      error: []
    };
  }

  const mostRecentEdit = offer.type === 'open' && offer.offerEdits.last();

  let processingState = offer.processingState;
  let status = offer.status;
  let error = offer.error;
  let delay = offer.delay || 0;
  let editTime = offer.createdAt;


  if (!mostRecentEdit) {
    return {
      delay,
      status,
      processingState: offer.processingState,
      editTime: offer.createdAt || '',
      error: offer.error
    };
  }

  const isRecentEdit = (new Date(mostRecentEdit.editTime).valueOf() + 12000) > new Date().valueOf();

  if (isRecentEdit && mostRecentEdit) {
    switch (mostRecentEdit.status) {
      case 'applied':
        processingState = 'submitted';
        editTime = mostRecentEdit.editTime;
        break;
      case 'failed':
        processingState = 'failed';
        status = 'failed';
        error = [{ messages: [FAILURE_REASONS[mostRecentEdit.failureReason.toUpperCase()]] }];
        editTime = mostRecentEdit.editTime;
        // TODO: error message
        break;
      case 'delayed':
        processingState = 'submitting';
        delay = mostRecentEdit.delay;
        status = 'delayed';
        editTime = mostRecentEdit.editTime;
        break;
      default:
        break;
    }
  }

  return {
    delay,
    error,
    status,
    processingState,
    editTime,
    mostRecentEdit: mostRecentEdit || false
  };
  // TODO: take offer, get delay and status
};

export const getCustomBetError = (error) => {
  if (!error) {
    return false;
  }

  const errorTitle = error.messages[0].split('.', 2)[0];

  return [
    ERROR_MESSAGES.INSUFFICIENT_FUNDS[0],
    ERROR_MESSAGES.UNAUTHORIZED_ACCESS[0],
    ERROR_MESSAGES.ODDS_NOT_AVAILABLE[0],
    ERROR_MESSAGES.INVALID_LEGS[0],
    ERROR_MESSAGES.NOT_AVAILABLE_IN_PLAY[0],
    ERROR_MESSAGES.EVENT_MUST_BE_OPEN[0],
    ERROR_MESSAGES.ODDS_TYPE_MISMATCH[0],
    ERROR_MESSAGES.BET_BUILDER_RESTRICTED_IE[0],
    'Max stake is'
  ].reduce((customError, errorSegment) => {
    // the actual value comes from the error message
    // we don't want to use another useState to store the local error
    // we take advantage of Redux store flow
    if (errorTitle.includes(errorSegment) && errorSegment === 'Max stake is') {
      return error.messages[0];
    }

    if (errorTitle.includes(errorSegment)) {
      return errorSegment;
    }

    return customError;
  }, '');
};
